import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import SelectItemToAdd from './TripItems/SelectItemToAdd'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import IconButton from 'components/Luxkit/Button/IconButton'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineTimesIcon from 'components/Luxkit/Icons/line/LineTimesIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import useToggle from 'hooks/useToggle'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

const Root = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: ${rem(366)};
  padding: ${rem(16)};
  transform: translate(-50%, -50%);
  background: ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${(props) => props.theme.borderRadius.M};
  box-shadow: ${props => props.theme.shadow.bottom.large};
`

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`
interface Props {
  tripId: string
}

export default function TooltipModal({ tripId }: Props) {
  const [isOpen, , , close] = useToggle(true)

  const openModal = useOpenModal()

  const onAddToTrip = useCallback(
    () => openModal(SelectItemToAdd, { tripId }),
    [openModal, tripId],
  )

  if (!isOpen) {
    return null
  }

  return (
    <Root>
      <VerticalSpacer gap={8}>
        <Group
          direction="horizontal"
          verticalAlign="center"
          horizontalAlign="space-between"
        >
          <Heading variant="heading6">Add something to your trip!</Heading>

          <Group direction="horizontal" verticalAlign="center">
            <IconButton
              kind="tertiary"
              variant="dark"
              size="small"
              shape="circle"
              data-testid="action-menu-button"
              aria-label="Card action menu"
              onClick={close}
            >
              <LineTimesIcon />
            </IconButton>
          </Group>
        </Group>

        <BodyText variant="medium">Try adding a hotel or flight</BodyText>
        <Buttons>
          <TextButton
            shape="round"
            kind="primary"
            variant="ghost"
            onClick={onAddToTrip}
          >
            Add to trip
          </TextButton>
        </Buttons>
      </VerticalSpacer>
    </Root>
  )
}
